import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {GlobalState} from '../../store/store.model';
import {map, take} from 'rxjs';
import {authenticated} from '../../modules/authentication/store/authentication.selectors';

export const loginRedirectGuard: CanActivateFn = () => {
  const _store = inject(Store<GlobalState>);
  const _router = inject(Router);

  return _store.select(authenticated).pipe(
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        _router.navigateByUrl('/tabs');
        return false;
      }
      return true;
    })
  );
};
